import { createContext } from 'react'

import { ProtectionContextType } from './types'

export const ProtectionContext = createContext<ProtectionContextType>({} as ProtectionContextType)
